/*jshint esnext: true */
/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Michelle Lykke - mlb@dis-play.dk
 Modified by:
 Client name: Danske Regioner
 Date of creation: 5.7.2017
 */


(function ($, dis) {
	"use strict";


	dis.JqueryModal = function () {
		dis.BaseModule.call(this);

		var dom = {},
			selfScope = this;


		function init() {

			// get all modals
			dom.triggers = $('a.open-modal');

			$.each(dom.triggers, function (index) {
				let currentTrigger = $(dom.triggers[index]);
				dom.modal = $(currentTrigger.attr('href'));

				if (dom.modal !== null && dom.trigger !== null) {

					// if password was wrong show modal again
					dom.errorReopen = dom.modal.find('.validation-summary-errors[data-valmsg-summary="true"]');

					dom.loginformnopopup = $(document).find("#login-form_no-popup");

					if(dom.loginformnopopup.length < 1)
					{
						if (dom.errorReopen.length > 0) {
							currentTrigger.modal({
								fadeDuration: 150
							});
						}
					}

					currentTrigger.click(function () {
						console.log($(this));

						$(this).modal({
							fadeDuration: 150
						});
						return false;
					});

				}
			});
		}

		selfScope.onReady(init);
	};

	dis.JqueryModal.prototype = new dis.BaseModule();
	dis.JqueryModal.constructor = dis.JqueryModal;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));